import dropdownMenu from "../../../shared/dropdownMenu";

export default () => {
  dropdownMenu();
};
